// import { ImagePortraitProps } from '@touche-lts/panel-ui/dist'
// import iconImage from '@touche/panel-ui.assets/svg/icon-image.svg'
import visa from 'assets/images/visa.png'
import masterCard from 'assets/images/master-card.png'

export * from './types'

// export const getMainImageSrcForObj = (object: any) => {
//   if (!object) return null
//   if (object.mainImage) return object.mainImage.url
//   if (object.image) return object.image.url
//   if (object.images && object.images.length) return object.images[0].url
// }

export const getLogoImageSrcForObj = (object: any): string => {
  if (!object) return null
  if (object.mainImage) return object.mainImage.url
  return (object.images || []).find(img => img.mainImage)?.url
}

export const getBackgroundImageSrcForObj = (object: any): string => {
  if (!object) return null
  // if (object.mainImage) return object.mainImage.url
  return (object.images || []).find(img => img.backgroundImage)?.url
}

// export const secureString = (value: string): string => {
//   if (!value || !value.length) return ''

//   return Array(value.length)
//     .fill('*')
//     .join('')
// }

// export const getImagePortraitProps = (
//   imageUrl: string,
//   noImagePreset: 'person' | 'image'
// ): ImagePortraitProps => {
//   if (imageUrl) {
//     return {
//       src: imageUrl
//     }
//   }

//   switch (noImagePreset) {
//     case 'image': {
//       return {
//         src: iconImage,
//         style: {
//           objectFit: 'none',
//           backgroundColor: '#ccccccb3',
//           opacity: 0.6
//         }
//       }
//     }
//     case 'person': {
//       return {
//         src: undefined,
//         style: {
//           // objectFit: 'none',
//           backgroundColor: '#cccccc70'
//           // opacity: 0.6
//         }
//       }
//     }
//   }
// }

export const generateLocalId = (): number => {
  return Number(0 + '.' + new Date().getMilliseconds())
}

export const isLocalId = (id: number): boolean => {
  return id < 1
}

export const getSelectOptions = (object: any): any => {
  return Object.values(object).map(type => ({
    label: type,
    value: type
  })) 
}

export const formatHTMLCardNumber = (num: number | string, hideFirstTwoDigits?: boolean): any => {
  try {
    let cardNumber = num.toString().replace(/[^0-9*]/g, '');
    if (hideFirstTwoDigits) {
      cardNumber = cardNumber.replace(/^.{2}/g, '**');
    }
    return {__html: `${cardNumber.match(/.{1,4}/g).join('&nbsp;&nbsp;&nbsp;')}`};
  } catch (error) {
    console.error(error);
    return {__html: ``};
  }
};

export const getCardTypeImg = (cardType?: number) => {
  if (cardType === 1) {
    return visa;
  }
  return masterCard;
}

export const formatErrorMessage = (error: any): string =>{
  return JSON.parse(error.message)?.errors.map((error:any) => error?.defaultMessage).join(",")
} 